var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video.type.toLowerCase() == 'wistia')?_c('Wistia',{attrs:{"video":_vm.video,"autoPlay":_vm.autoPlay}}):_c('YouTube',{attrs:{"video":_vm.video,"autoPlay":_vm.autoPlay}})}
var staticRenderFns = []

export { render, staticRenderFns }